export default __webpack_public_path__ + "static/media/Weslean_Impact_gold_navy.0d2391f2.svg";